import { render, staticRenderFns } from "./StateBrowserBuffer.vue?vue&type=template&id=56ad29e1&"
import script from "./StateBrowserBuffer.vue?vue&type=script&lang=js&"
export * from "./StateBrowserBuffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports